export default __webpack_public_path__ + "img/purple.ca385ba4.png";